import React, { createContext, useContext } from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import useTailwindBrand from "../Theme/useTailwindBrand";

/**
 * Habillage des rubriques des paramètres : « legacy » (cartes MUI actuelles)
 * ou « v2 » (cartes des maquettes 8a à 8e, le titre de la rubrique étant déjà
 * porté par le menu de gauche). Les étapes existantes ne changent pas, seul
 * le conteneur lit ce contexte.
 */
export type SettingsStyleVariant = "legacy" | "v2";
export const SettingsStyleContext = createContext<SettingsStyleVariant>("legacy");
export const useSettingsStyle = () => useContext(SettingsStyleContext);

export interface SettingsProps {
  title?: string;
  subtitle?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  height?: string | number;
}

const Settings: React.FC<SettingsProps> = ({ title, subtitle, icon, children, height }) => {
  const { brandConfig } = useTailwindBrand();
  const variant = useSettingsStyle();

  if (variant === "v2") {
    return (
      <Grid container spacing={2}>
        {children}
      </Grid>
    );
  }

  return (
    <Card
      variant="outlined"
      sx={{
        // overflow: "hidden",
        borderRadius: 2,
        boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
        border: "1px solid",
        borderColor: "grey.200",
        height: height || "auto",
      }}
      className="overflow-y-auto"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          px: { xs: 2, sm: 3 },
          pt: { xs: 2, sm: 3 },
          pb: 1,
        }}
      >
        {icon}
        <Box>
          <Typography
            variant="h5"
            component="h2"
            fontWeight="bold"
            fontFamily={brandConfig.fontFamily}
            color={brandConfig.colors?.primary ?? "text.primary"}
          >
            {title}
          </Typography>
          <Typography component="h5" sx={{ color: brandConfig.colors.text, fontFamily: brandConfig.fontFamily }} className="text-sm">
            {subtitle}
          </Typography>
        </Box>
      </Box>
      <CardContent sx={{ p: { xs: 2, sm: 3 }, pt: 0 }}>
        <Grid container spacing={3}>
          {children}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Settings;
